import { render, staticRenderFns } from "./ServicoCancelado.vue?vue&type=template&id=fc12f852&scoped=true&"
import script from "./ServicoCancelado.vue?vue&type=script&lang=js&"
export * from "./ServicoCancelado.vue?vue&type=script&lang=js&"
import style0 from "./ServicoCancelado.vue?vue&type=style&index=0&id=fc12f852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc12f852",
  null
  
)

export default component.exports